var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5E5E5E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3073 8.11574V10.6544H18.7973C18.7447 10.6471 18.6833 10.6431 18.6213 10.6431C18.26 10.6431 17.9307 10.7784 17.6807 11.0017L17.682 11.0004C17.4987 11.2564 17.3893 11.5757 17.3893 11.9211C17.3893 11.9624 17.3907 12.0037 17.394 12.0444V12.0391V13.8564H20.2133L19.84 16.7031H17.398V24.0004H14.4533V16.7024H12V13.8564H14.4533V11.7597C14.4487 11.6917 14.446 11.6117 14.446 11.5317C14.446 10.5464 14.8293 9.6504 15.4547 8.98507L15.4527 8.98707C16.1007 8.37374 16.978 7.99707 17.9427 7.99707C18.0027 7.99707 18.0627 7.9984 18.1227 8.00174H18.114C18.1927 8.0004 18.2847 7.99974 18.3773 7.99974C19.0573 7.99974 19.7273 8.0424 20.3847 8.12507L20.3067 8.11707L20.3073 8.11574Z",
    className: "fill",
    fill: "#EFEDEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 16,
    fill: "white",
    transform: "translate(12 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9242e1a9ec9a7811b83a442196cf78e4.svg";
export { ForwardRef as ReactComponent };